import { StarOutlined, KeyOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import Tooltip from 'antd/lib/tooltip';
import React, { ReactElement } from 'react';

import FieldType from './FieldType';
import classes from './SchemaPanelHeader.module.css';

interface Field {
  name?: string;
}

interface ValidationRules {
  required?: boolean;
}

interface SchemaPanelHeaderProps {
  deprecated?: boolean;
  field?: Field;
  primaryKey?: boolean;
  singleValue?: boolean;
  type: string;
  validationRules?: ValidationRules;
}

function SchemaPanelHeader({
  deprecated,
  field,
  primaryKey,
  singleValue,
  type,
  validationRules,
}: SchemaPanelHeaderProps): ReactElement {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Typography.Text className={classes.heading}>
        {deprecated ? (
          <span className={classes.span} style={{ color: '#999AA8' }}>
            {field?.name}
          </span>
        ) : (
          <span className={classes.span}>{field?.name}</span>
        )}
      </Typography.Text>{' '}
      {primaryKey ? (
        <Tooltip title="Primary Key">
          <KeyOutlined style={{ marginRight: 5 }} />
        </Tooltip>
      ) : null}{' '}
      <FieldType type={type} />
      {validationRules?.required ? (
        <Tooltip title="Required">
          <StarOutlined />
        </Tooltip>
      ) : null}{' '}
      {singleValue ? null : (
        <Tooltip title="Multi Value">
          <div style={{ marginLeft: 5, fontWeight: 'bold' }}>[ ]</div>
        </Tooltip>
      )}
      {deprecated ? <div style={{ fontSize: 12, color: '#999AA8', marginLeft: 10 }}>(deprecated)</div> : null}
    </div>
  );
}

export default SchemaPanelHeader;
